/** Minimal subset of Telegram WebApp API used by openExternalUrl */
export interface TelegramWebAppLike {
  openLink: (url: string) => void;
}

export function openExternalUrl(url: string, webApp?: TelegramWebAppLike | null): void {
  if (webApp) {
    // Telegram Mini App — open in external browser
    webApp.openLink(url);
  } else {
    // Regular browser — open in new tab
    window.open(url, '_blank');
  }
}
